import { useEffect, useState } from 'react';
import PackageService from '../../../api/super-admin/PackageService';
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';

export default function PaymentHistory() {
  const [packageList, setPackageList] = useState([]);
  const [packageDetails, setPackageDetails] = useState({
    inv_no: 0,
    sub_total_price: 0,
    discount_price: 0,
    total_price: 0,
    package_history: {
      title: '',
      created_at: '',
      discount_percentage: 0,
      discount_amount: 0,
    },
  });
  const [invoiceDetails, setInvoiceDetails] = useState({
    inv_no: 0,
    sub_total_price: 0,
    discount_price: 0,
    total_price: 0,
    package_history: {
      title: '',
      created_at: '',
      discount_percentage: 0,
      discount_amount: 0,
    },
    invoice_items:[{
      price:0,
      title:''
    }]
  });
  const [packageDetailsModal, setPackageDetailsModal] = useState(false);
  const [invoiceModal, setInvoiceModal] = useState(false);

  useEffect(() => {
    getActivePackageList();
  }, []);

  const handleViewDetails = (id:number) => {
    setPackageDetailsModal(true);
    const data = { id: id };
    PackageService.getPackagePaymentDetails(data).then(
      (res:any) => {
        if (res?.data?.success) {
          setPackageDetails(res?.data?.data);
        } else {
          toast.error(res?.data?.message, { theme: 'dark' });
          setPackageDetails({
            inv_no: 0,
            sub_total_price: 0,
            discount_price: 0,
            total_price: 0,
            package_history: {
              title: '',
              created_at: '',
              discount_percentage: 0,
              discount_amount: 0,
            },
          });
        }
      },
      (err:any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' });
      }
    );
  };

  const handleViewInvoice = (id:number) => {
    setInvoiceModal(true);
    const data = { id: id };
    PackageService.getPackagePaymentInvoice(data).then(
      (res:any) => {
        if (res?.data?.success) {
          setInvoiceDetails(res?.data?.data);
        } else {
          toast.error(res?.data?.message, { theme: 'dark' });
          setInvoiceDetails({
            inv_no: 0,
            sub_total_price: 0,
            discount_price: 0,
            total_price: 0,
            package_history: {
              title: '',
              created_at: '',
              discount_percentage: 0,
              discount_amount: 0,
            },
            invoice_items:[{
              price:0,
              title:''
            }]
          });
        }
      },
      (err:any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' });
      }
    );
  };

  const closeModal = () => {
    setPackageDetailsModal(false);
    setInvoiceModal(false);
  };

  const getActivePackageList = () => {
    let data:any = {
      limit: 10,
      offset: 0,
    };
    PackageService.getAllPackageList(data).then(
      (res:any) => {
        if (res?.data?.success) {
          setPackageList(res?.data?.data);
        } else {
          toast.error(res?.data?.message, { theme: 'dark' });
          setPackageList([]);
        }
      },
      (err:any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' });
      }
    );
  };

  const downloadInvoiceAsPDF = () => {
    const doc = new jsPDF();
  
    doc.setFontSize(16);
    doc.text('Invoice Details', 14, 20);
    
    doc.setFontSize(12);
    
    // General Information
    doc.setFont("helvetica", "bold");
    doc.text('Title:', 14, 30);
    doc.setFont("helvetica", "normal");
    doc.text(invoiceDetails.package_history.title, 70, 30); // Adjusted x-coordinate for value
    
    doc.setFont("helvetica", "bold");
    doc.text('Invoice No:', 14, 40);
    doc.setFont("helvetica", "normal");
    doc.text(invoiceDetails.inv_no.toString(), 70, 40); // Adjusted x-coordinate for value
    
    // Price Information
    doc.setFont("helvetica", "bold");
    doc.text('Sub Total Price:', 14, 50);
    doc.setFont("helvetica", "normal");
    doc.text(invoiceDetails.sub_total_price.toString(), 70, 50); // Adjusted x-coordinate for value
    
    doc.setFont("helvetica", "bold");
    doc.text('Discount Price:', 14, 60);
    doc.setFont("helvetica", "normal");
    doc.text(invoiceDetails.discount_price.toString(), 70, 60); // Adjusted x-coordinate for value
    
    doc.setFont("helvetica", "bold");
    doc.text('Total Price:', 14, 70);
    doc.setFont("helvetica", "normal");
    doc.text(invoiceDetails.total_price.toString(), 70, 70); // Adjusted x-coordinate for value
    
    // Discount Information
    doc.setFont("helvetica", "bold");
    doc.text('Discount Amount:', 14, 80);
    doc.setFont("helvetica", "normal");
    doc.text(invoiceDetails.package_history.discount_amount.toString(), 70, 80); // Adjusted x-coordinate for value
    
    doc.setFont("helvetica", "bold");
    doc.text('Discount Percentage:', 14, 90);
    doc.setFont("helvetica", "normal");
    doc.text(invoiceDetails.package_history.discount_percentage.toString(), 70, 90); // Adjusted x-coordinate for value
    
    // Package Information
    doc.setFont("helvetica", "bold");
    doc.text('Package Name:', 14, 100);
    doc.setFont("helvetica", "normal");
    doc.text(invoiceDetails?.invoice_items[0]?.title, 70, 100); // Adjusted x-coordinate for value
    
    doc.setFont("helvetica", "bold");
    doc.text('Package Price:', 14, 110);
    doc.setFont("helvetica", "normal");
    doc.text(invoiceDetails?.invoice_items[0]?.price.toString(), 70, 110); // Adjusted x-coordinate for value
    
    // Date Information
    doc.setFont("helvetica", "bold");
    doc.text('Created at:', 14, 120);
    doc.setFont("helvetica", "normal");
    doc.text(new Date(invoiceDetails.package_history.created_at).toLocaleDateString(), 70, 120); // Adjusted x-coordinate for value
    
    doc.save(`invoice_${invoiceDetails.inv_no}.pdf`);
  };
  
  

  return (
    <>
      <button
        className='bg-transparent border-0 mb-5'
        onClick={() => {
          window.history.back();
        }}
      >
        <i
          className='fa fa-angle-left py-2 px-3'
          aria-hidden='true'
          style={{ background: '#fff', borderRadius: '50%' }}
        ></i>{' '}
        <span className='fw-bold fs-5 px-2'>Back</span>
      </button>
      {/* // card Billing */}
      <div className='col-lg-10 px-3'>
        <div className='row px-3 py-5' style={{ background: '#1C1E1F', borderRadius: 10 }}>
          <h5 className='text-white'>Trial Plan</h5>
          <h6 className='text-white'>₦ 0.00</h6>
          <div className='col-lg-6 text-lg-start text-center'>
            <p className='text-white m-0'>Valid till 30th September</p>
            <p className='text-white m-0'>2022</p>
          </div>
          <div className='col-lg-6 text-lg-end text-center'>
            <button type='button' className='btn btn-success fs-9'>
              Upgrade Plan
            </button>
          </div>
        </div>
      </div>
      {/* Gap */}
      <div className='my-6 col-12' />

      {/* History */}
      <h5 className='mb-4' style={{ color: '#8E8E8E' }}>
        Payment History
      </h5>
      <div className='col-lg-10 col-md-10 mb-5'>
        <div className='table-responsive'>
          <div className='d-flex justify-content-between w-100 px-3'>
            <td className='d-flex w-lg-25'>
              <span className='text-dark d-block fs-5 fw-bold'>Title</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark d-block fs-5 fw-bold'>Invoice No</span>
            </td>
            <td className='text-start w-lg-25'>
              <span className='text-dark d-block fs-5 fw-bold'>Sub Total Price</span>
            </td>
            <td className='text-start w-lg-25'>
              <span className='text-dark d-block fs-5 fw-bold'>Discount Price</span>
            </td>
            <td className='text-start w-lg-25'>
              <span className='text-dark d-block fs-5 fw-bold'>Total Price</span>
            </td>
            <td className='text-start w-lg-25'></td>
            <td className='text-start w-lg-25'></td>
          </div>
          {packageList.map((e:any, index) => (
            <div
              className='px-3 py-4 mb-2 bg-white d-flex justify-content-between w-100'
              key={index}
              style={{ borderRadius: 5 }}
            >
              <td className='d-flex w-lg-25'>
                  <span className='text-dark d-block fs-6 d-flex align-items-center'>
                    {e?.package_history?.title}
                  </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className='text-dark d-block fs-6 d-flex align-items-center'>
                  {e?.inv_no}
                </span>
              </td>
              <td className='d-flex text-start w-lg-25'>
                <span className='text-dark d-block fs-6 d-flex align-items-center'>
                  {e?.sub_total_price}
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className='text-dark d-block fs-6 d-flex align-items-center'>
                  {e?.discount_price}
                </span>
              </td>
              <td className='d-flex w-lg-25'>
                <span className='text-dark d-block fs-6 d-flex align-items-center'>
                  {e?.total_price}
                </span>
              </td>
              <td className='d-flex justify-content-end w-lg-50'>
                <button
                  type='button'
                  onClick={() => handleViewDetails(e.id)}
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm px-12 py-0'
                  style={{backgroundColor: '#007bff', color: '#ffffff', fontSize: '11px'}}
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Details'
                >
                  Details
                </button>
                <button
                  type='button'
                  onClick={() => handleViewInvoice(e.id)}
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-6 px-12 py-0'
                  style={{backgroundColor: '#28a745', color: '#ffffff', fontSize: '11px'}}
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  title='Invoice'
                >
                  Invoice
                </button>
              </td>
            </div>
          ))}
        </div>
      </div>
      {/* MODAL => Note */}
      {packageDetailsModal && (
        <div className='modal' tabIndex={-1} role='dialog' style={{ display: 'block' }}>
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>Payment Package Details</h5>
                <button type='button' className='btn-close' onClick={closeModal}></button>
              </div>

              <div className='modal-body'>
                <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-evenly' }}>
                  {' '}
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='title' className='fw-bold align-self-center'>
                      Title:
                    </label>
                    <p>{packageDetails?.package_history?.title}</p>
                  </div>
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Invoice No:
                    </label>
                    <p>{packageDetails?.inv_no}</p>
                  </div>
                </div>

                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginTop: 10,
                  }}
                >
                  {' '}
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Discount Price:
                    </label>
                    <p>{packageDetails?.discount_price}</p>
                  </div>
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='title' className='fw-bold align-self-center'>
                      Total Price:
                    </label>
                    <p>{packageDetails?.total_price}</p>
                  </div>
                </div>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginTop: 10,
                  }}
                >
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Sub Total Price:
                    </label>
                    <p>{packageDetails?.sub_total_price}</p>
                  </div>
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Discount Amount:
                    </label>
                    <p>{packageDetails?.package_history?.discount_amount}</p>
                  </div>
                </div>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginTop: 10,
                  }}
                >
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='title' className='fw-bold align-self-center'>
                      Discount Percentage:
                    </label>
                    <p>{packageDetails?.package_history?.discount_percentage}</p>
                  </div>
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Created at:
                    </label>
                    <p>{`${new Date(packageDetails?.package_history?.created_at).getUTCDate()}, ${new Date(
                      packageDetails?.package_history?.created_at
                    ).toLocaleString('default', { month: 'long' })}, ${new Date(
                      packageDetails?.package_history?.created_at
                    ).getUTCFullYear()}`}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {packageDetailsModal && <div className='modal-backdrop fade show'></div>}

      {/* MODAL => Invoice */}
      {invoiceModal && (
        <div className='modal' tabIndex={-1} role='dialog' style={{ display: 'block' }}>
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>Invoice Details</h5>
                <button type='button' className='btn-close' onClick={closeModal}></button>
              </div>

              <div className='modal-body' id='invoice-content'>
                <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-evenly' }}>
                  {' '}
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='title' className='fw-bold align-self-center'>
                      Title:
                    </label>
                    <p>{invoiceDetails?.package_history?.title}</p>
                  </div>
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Invoice No:
                    </label>
                    <p>{invoiceDetails?.inv_no}</p>
                  </div>
                </div>

                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginTop: 10,
                  }}
                >
                  {' '}
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Discount Price:
                    </label>
                    <p>{invoiceDetails?.discount_price}</p>
                  </div>
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='title' className='fw-bold align-self-center'>
                      Total Price:
                    </label>
                    <p>{invoiceDetails?.total_price}</p>
                  </div>
                </div>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginTop: 10,
                  }}
                >
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Sub Total Price:
                    </label>
                    <p>{invoiceDetails?.sub_total_price}</p>
                  </div>
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Discount Amount:
                    </label>
                    <p>{invoiceDetails?.package_history?.discount_amount}</p>
                  </div>
                </div>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginTop: 10,
                  }}
                >
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Package name:
                    </label>
                    <p>{invoiceDetails?.invoice_items[0]?.title}</p>
                  </div>
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Package Price:
                    </label>
                    <p>{invoiceDetails?.invoice_items[0]?.price}</p>
                  </div>
                </div>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginTop: 10,
                  }}
                >
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='title' className='fw-bold align-self-center'>
                      Discount Percentage:
                    </label>
                    <p>{invoiceDetails?.package_history?.discount_percentage}</p>
                  </div>
                  <div className='form-group' style={{ width: '40%' }}>
                    <label htmlFor='Invoice No' className='fw-bold align-self-center'>
                      Created at:
                    </label>
                    <p>{`${new Date(invoiceDetails?.package_history?.created_at).getUTCDate()}, ${new Date(
                      invoiceDetails?.package_history?.created_at
                    ).toLocaleString('default', { month: 'long' })}, ${new Date(
                      invoiceDetails?.package_history?.created_at
                    ).getUTCFullYear()}`}</p>
                  </div>
                </div>
              </div>

              <div className='modal-footer'>
                <button type='button' className='btn btn-primary' onClick={downloadInvoiceAsPDF}>
                  Download as PDF
                </button>
                <button type='button' className='btn btn-secondary' onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {invoiceModal && <div className='modal-backdrop fade show'></div>}
    </>
  );
}
